import { Box, Dialog } from "@mui/material";

interface Props {
  open: boolean;
  handleClose: any;
  children: any;
}

const Popup = ({ open, handleClose, children }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth="md"
      PaperProps={{ sx: { margin: { xs: 1, sm: 4 } } }}
    >
      <Box p={{ xs: 2, sm: 4 }}>{children}</Box>
    </Dialog>
  );
};

export default Popup;
